<template>
    <svg width="16" height="30" viewBox="0 0 16 30" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 30L16 30V14.5415C16 8.12227 7.6 4.36903e-05 0 0V6.41921C2.93333 6.41921 6.93333 10.6114 6.93333 14.5415H0L0 30Z"/>
    </svg>
</template>
